import { render, staticRenderFns } from "./ActionEmail.vue?vue&type=template&id=f4ca4fe4&"
import script from "./ActionEmail.vue?vue&type=script&lang=js&"
export * from "./ActionEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports